<template>
    <div class="app-icon-alert">
        <div class="alert-icon">
            <span v-html="$icon('light')"></span>
        </div>
        <div class="alert-body" v-html="info"></div>
    </div>
</template>

<script>
    export default {
        props: ['info']
    }
</script>

<style lang="scss">
    .app-icon-alert {
        padding: 35px 0;
        border-radius: 37px;
        box-shadow: 0 10px 30px 0 rgba(0, 84, 255, 0.14);
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        position: relative;

        .alert-icon {
            width: 57px;
            height: 57px;
            background-color: $primary-blue;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50rem;
            z-index: 30;
            position: absolute;
            top: -25px;
            left: 50%;
            transform: translateX(-50%);
        }

        .alert-body {
            font-size: 20px;
            font-weight: $font-light;
            line-height: 1.5;
            text-align: center;
            color: $black;
        }
    }
</style>
